/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import {
  MANDATE_EXCLUSIVE_RENTAL_MANAGEMENT,
  MANDATE_SIMPLE_RENTAL
} from '../../enums/MandateTypes.mjs'
import { round } from '../math.mjs'

export function calculateAgencyFeesPercentage (mandate) {
  const { agencyFees, price } = mandate
  // todo calculate % depending of tax included or not
  return round((agencyFees * 100) / price, 4)
}

export function calculateManagementFeesPercentage (mandate) {
  const { managementFees, price } = mandate
  // todo calculate % depending of tax included or not
  return round((managementFees * 100) / price, 4)
}

export function isManagedMandate (mandate) {
  return mandate.type === MANDATE_EXCLUSIVE_RENTAL_MANAGEMENT
}

export function getMandateReference (mandate) {
  return `${mandate.type}${mandate.number}`
}

export function isRentalMandate (mandate) {
  return mandate.type === MANDATE_EXCLUSIVE_RENTAL_MANAGEMENT ||
    mandate.type === MANDATE_SIMPLE_RENTAL
}
